module.exports = __webpack_public_path__ + "static/media/afrijula_gm landing banner 3.45eb3970.jpg";